// src/pages/Diagnostics.tsx

import { CheckTwoTone, CloseTwoTone, PublicTwoTone } from '@mui/icons-material'
import {
  Card,
  CardContent,
  CardHeader,
  Divider,
  IconButton,
  InputAdornment,
  Paper,
  Stack,
  TextField,
  useTheme,
} from '@mui/material'
import { useNavigate } from 'react-router-dom'
import JsonView from 'react18-json-view'

import { FolderPool } from '@/types/domain/folder'
import { SensorPool } from '@/types/domain/sensor'

import {
  OperatorData,
  useFolderPool,
  useOperator,
  useSensorPool,
} from '../hooks'

export const Diagnostics = () => {
  const opData: OperatorData = useOperator()
  const navigate = useNavigate()

  const fPool: FolderPool = useFolderPool()
  const sPool: SensorPool = useSensorPool()

  const theme = useTheme()

  const env = import.meta.env

  const isLink = key => String(Object.values(env)[key]).includes('http://')

  const isBool = key =>
    String(Object.values(env)[key]) === 'true' ||
    String(Object.values(env)[key]) === 'false'

  return opData?.isAdmin ? (
    <Paper sx={{ p: 2 }}>
      <Card>
        <CardHeader
          title={'process environment'}
          action={
            <IconButton onClick={() => navigate(-1)}>
              <CloseTwoTone />
            </IconButton>
          }
        />
        <CardContent>
          <Stack spacing={1}>
            {[...Object.keys(env)].map((item, key) => (
              <TextField
                key={item}
                InputProps={{
                  readOnly: true,
                  startAdornment: (
                    <InputAdornment position={'start'}>{item}</InputAdornment>
                  ),
                  endAdornment: isLink(key) ? (
                    <InputAdornment position={'end'}>
                      <IconButton
                        onClick={() =>
                          window.open(Object.values(env)[key], '_blank')
                        }
                      >
                        <PublicTwoTone />
                      </IconButton>
                    </InputAdornment>
                  ) : isBool(key) ? (
                    <InputAdornment position={'end'}>
                      {String(Object.values(env)[key]) === 'true' ? (
                        <IconButton sx={{ color: theme.palette.success.main }}>
                          <CheckTwoTone />
                        </IconButton>
                      ) : (
                        <IconButton sx={{ color: theme.palette.error.main }}>
                          <CloseTwoTone />
                        </IconButton>
                      )}
                    </InputAdornment>
                  ) : null,
                }}
                value={Object.values(env)[key] || ''}
              />
            ))}
          </Stack>
        </CardContent>
      </Card>

      <Divider />

      <Card>
        <CardHeader title={'fPool'} />
        <CardContent>
          <JsonView collapsed={true} src={fPool.map(i => i.attributes)} />
        </CardContent>
      </Card>

      <Card>
        <CardHeader title={'sPool'} />
        <CardContent>
          <JsonView collapsed={true} src={sPool.map(i => i.attributes)} />
        </CardContent>
      </Card>
    </Paper>
  ) : null
}
